module.exports = __webpack_public_path__ + "assets/images/android_ride_this-4c9c62848f705cc9f084e3ad25189256.webm";